import React from "react";
import Drawer from "@material-ui/core/Drawer";
import SidenavContent from "./SidenavContent";
import UserInfo from "components/UserInfo";
import { useTranslation } from "react-i18next";
import classes from "./SidenavContainer.module.scss";

const SidenavContainer = ({
  drawerStyle,
  type,
  navCollapsed,
  onToggleCollapsedNav,
}) => {
  const { i18n } = useTranslation();

  return (
    <div
      className={`app-sidebar d-none ${drawerStyle} ${
        i18n.dir() === "ltr" ? classes.root : ""
      }`}
    >
      <Drawer
        className="app-sidebar-content"
        variant={type}
        open={type.includes("temporary") ? navCollapsed : true}
        onClose={onToggleCollapsedNav}
        classes={{
          paper: "side-nav",
        }}
      >
        <UserInfo width={120} margin={"0"} />
        <SidenavContent />
      </Drawer>
      <div
        className={i18n.dir() === "ltr" ? "uptin-sidebar-ltr" : "uptin-sidebar"}
      ></div>
    </div>
  );
};

export default SidenavContainer;
